<template>
  <div>
    <div class="item-box-content" v-show="!isShowProductSelection">
      <div>
        <el-button
          v-show="$route.query.data!=='purchase'"
          @click="onProductSelection"
          type="primary"
          plain
        >产品选型</el-button>
        <el-button
          v-show="$route.query.data!=='purchase'"
          @click="importProduct"
          type="primary"
          plain
        >导入产品</el-button>
       <el-button
        v-show="$route.query.data!=='purchase'"
          @click="batchSettingType"
          type="primary"
          plain
        >批量设置类型</el-button>
        <el-button
          v-show="$route.query.data!=='purchase'"
          @click="onBulkEditDeliveryTime"
          type="primary"
          plain
        >批量设置货期</el-button>
      </div>
      <!-- <div
        v-show="$route.query.data==='purchase'"
        class="title-font-style"
        style="margin-bottom:20px;text-aling:left"
      >
        <span>采购区</span>
      </div> -->
      <el-row v-show="$route.query.data==='purchase'">
      <el-col :span="12">
        <div>
          <span class="bold"></span>
          <span class="basic">采购区</span>
        </div>
      </el-col>
      <el-col
        :span="12"
        style="text-align:right;"
      >
       <el-button
          @click="batchSettingType"
          type="primary"
          plain
        >批量设置类型</el-button>
      </el-col>
    </el-row>
      <el-table
        v-show="$route.query.data!=='purchase'"
        style="margin-top:20px;"
        border
        :max-height="414"
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
       >
        <el-table-column fixed type="selection" width="35"></el-table-column>
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ocUnit" label="单位"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="$route.query.type !== '生成合同'"
          prop="proCount"
          label="数量"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="类型">
          <template slot-scope="scope">
            <el-select v-model="scope.row.proExtype" @change="onOcExtime">
              <el-option value="现货" label="现货"></el-option>
              <el-option value="期货" label="期货"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop='ocExtime' label='货期'>
        <template slot-scope="scope">
                <el-row :gutter="5">
                  <el-col :span="20">
                    <el-input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      v-model.number="scope.row.ocExtime"
                      label="请输入期望货期"
                      @change="onOcExtime"
                    ></el-input>
                  </el-col>
                  <el-col :span="4">天</el-col>
                </el-row>
              </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="$route.query.type !== '生成合同'"
          prop="purchasePrice"
          label="单品报价"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="$route.query.type === '生成合同'"
          prop="proCount"
          label="数量"
        >
          <template slot-scope="scope">
            <el-input-number
              :min="1"
              style="width:100%;"
              controls-position="right"
              :precision="0"
              v-model="scope.row.proCount"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column v-if="$route.query.type === '生成合同'" prop="purchasePrice" label="采购单价">
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              style="width:100%;"
              :controls="false"
              :precision="2"
              v-model="scope.row.purchasePrice"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column v-if="$route.query.type === '生成合同'" prop="purchasePrice" label="采购总价">
          <template
            slot-scope="scope"
          >{{ (scope.row.purchasePrice * scope.row.proCount).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column v-if="$route.query.type === '生成合同'" prop label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="remove(scope.row, scope.$index)" size="small">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-show="$route.query.data==='purchase'"
        style="margin-top:20px;"
        :max-height="420"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
       >
        <el-table-column fixed type="selection" width="35"></el-table-column>
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proUnit" label="单位"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stockupCount" label="数量"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="cbPrice" label="采购单价">
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              style="width:100%;"
              controls-position="right"
              :precision="2"
              v-model="scope.row.cbPrice"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="类型">
          <template slot-scope="scope">
            <el-select v-model="scope.row.proExtype">
              <el-option value="现货" label="现货"></el-option>
              <el-option value="期货" label="期货"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="ocExtime" label="货期">
          <template slot-scope="scope">{{scope.row.cbExtimeValue+'天'}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="proPrice" label="面价"></el-table-column>
        <el-table-column prop="deliveryTime" min-width="100" label="预计发货时间">
          <template slot-scope="scope">{{scope.row.deliveryTime|dateFilter}}</template>
        </el-table-column>
      </el-table>
      <h4>总计</h4>
      <el-table
        style="margin-top:20px"
        border
        ref="tableRef"
        :data="listTotal"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column prop="variety" label="产品种类"></el-table-column>
        <el-table-column prop="total" label="报价总额"></el-table-column>
      </el-table>
      <p style="color:#D35E5E;">*采购单价是供应商的实际报价</p>
    </div>
    <!-------------- 产品选型 -------------->
    <product-selection
      :tableList="list"
      ref="productSelectionRefs"
      @onMyEnquiry="onMyEnquiry"
      v-show="isShowProductSelection"
      :orderType="myPurchaseOrder"
    ></product-selection>
  <el-dialog title="批量设置类型" :visible.sync="typeDisableDialog" width="437px">
    <el-form label-width="100px">
       <el-form-item label="类型：" :rules="filter_rules({required:true})">
        <el-select v-model="type" style="width:240px">
          <el-option label="现货" value="现货"></el-option>
          <el-option label="期货" value="期货"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="typeOnSubmit">确 定</el-button>
      <el-button @click="typeDisableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
  <el-dialog title="批量设置货期" :visible.sync="disableDialog" width="437px">
    <el-form label-width="100px">
      <el-form-item label="货期：" :rules="filter_rules({required:true})">
        <el-input
          style="width:50%"
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          v-model="deliveryTime"
          label="请输入期望货期"
        ></el-input>
        <span style="margin-left:10px">天</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
    <!-- 导入产品 -->
    <lead-in @onRefresh="onRefresh" ref="leadInRefs"></lead-in>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import leadIn from '@/components/leadIn/index'

import productSelection from '@/components/ProductSelections/productSelection' // 产品选型
export default {
  components: {
    'product-selection': productSelection,
    'lead-in': leadIn
  },
  data() {
    return {
      disableDialog: false, // 货期
      deliveryTime: '', // 货期
      checkList: [],
      typeDisableDialog: false, // 类型
      type: '', // 类型
      list: [],
      listTotal: [{ variety: 0, total: 0 }],
      isShowProductSelection: false, // 是否显示产品选型
      myPurchaseOrder: '我的采购单'
      // myPurchaseJoin: '加入询价单'
    }
  },
  mounted() {
    if (this.$route.query.data === 'purchase') {
      this.list = this.$store.state.generateContactList
      if (this.$store.state.generateContactList.length === 0) {
        this.$router.push({
          name: 'purchasePlanList'
        })
      }
    }
  },
  watch: {
    list: {
      // 总额
      handler(newVal) {
        if (newVal) {
          if (this.$route.query.data === 'purchase') {
            this.listTotal[0].variety = 0
            this.listTotal[0].total = 0
            this.list.forEach(item => {
              this.listTotal[0].variety += 1
              this.listTotal[0].total += item.stockupCount * item.cbPrice
            })
            this.listTotal[0].total = this.listTotal[0].total.toFixed(2)
            const params = JSON.parse(JSON.stringify(this.list))
            this.$emit('productTypesChoosing', params)
          } else {
            this.listTotal[0].variety = 0
            this.listTotal[0].total = 0
            this.list.forEach(item => {
              this.listTotal[0].variety += 1
              this.listTotal[0].total += item.purchasePrice * item.proCount
            })
            this.listTotal[0].total = this.listTotal[0].total.toFixed(2)
            const params = JSON.parse(JSON.stringify(this.list))
            this.$emit('productTypesChoosing', params)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.checkList = val
    },
    // 批量设置类型
    batchSettingType() {
      if (this.checkList.length > 0) {
        this.typeDisableDialog = true
      } else {
        this.$message.error('请选择一条或多条数据')
      }
    },
    typeOnSubmit() {
      if (this.type === '') {
        this.$message.error('请选择类型')
      } else {
        this.checkList.forEach(ele => {
          ele.proExtype = this.type
        })
        this.typeDisableDialog = false
        this.onOcExtime()
      }
    },
    // 批量设置货期
    onBulkEditDeliveryTime() {
      if (this.checkList.length > 0) {
        this.deliveryTime = ''
        this.disableDialog = true
      } else {
        this.$message.error('请选择一条或多条数据')
      }
    },
    onSubmit() {
      if (this.deliveryTime === '') {
        this.$message.error('请填写货期')
      } else {
        this.checkList.forEach(ele => {
          ele.ocExtime = this.deliveryTime
        })
        this.disableDialog = false
        this.onOcExtime()
      }
    },
    // 修改货期合并数量处理
    onOcExtime() {
      const arr = this.list.reduce((obj, item) => {
        const find = obj.find((i) => i.proId === item.proId && +i.ocExtime === +item.ocExtime && i.proExtype === item.proExtype)
        const _d = item
        find ? (find.proCount += item.proCount) : obj.push(_d)
        return obj
      }, [])
      this.list = JSON.parse(JSON.stringify(arr))
    },
    // 移除
    remove(val, index) {
      this.list.splice(index, 1)
      // listTotal
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 产品选型
    onProductSelection() {
      this.isShowProductSelection = true
      this.$refs.productSelectionRefs.getOnInitial(this.$route.query.type) // 点击产品选型初始化
    },
    // 返回我的采购单
    onMyEnquiry(val) {
      val.forEach(ele => {
        ele.proExtype = ele.proExtype || '现货'
        ele.ocExtime = ele.ocExtime || 1
      })
      this.list = val
      const params = JSON.parse(JSON.stringify(this.list))
      this.$emit('productTypesChoosing', params)
      this.onOcExtime()
      this.isShowProductSelection = false
    },
    // 导入产品
    importProduct() {
      this.$refs.leadInRefs.onLeadIn(
        this.$store.state.productInformationGuid,
        '生成合同（采购生成）-导入产品'
      )
    },
    onRefresh(data) {
      data.forEach(ele => {
        this.list.push(ele)
      })
      this.onOcExtime()
      const params = JSON.parse(JSON.stringify(this.list))
      this.$emit('productTypesRefresh', params)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
